export namespace FormFieldUtils {
  export const imageRecordFormats = ['.jpeg', '.jpg', '.png', '.webp'];

  export type AllowedRecordFormats = 'any' | 'image';

  export function getInputAcceptFileAttribute(allowedRecordFormats: FormFieldUtils.AllowedRecordFormats[]): string {
    if (allowedRecordFormats == null || allowedRecordFormats.includes('any') || allowedRecordFormats.length === 0) {
      return '';
    }

    const accepts: string[] = [];

    if (allowedRecordFormats.includes('image')) {
      accepts.push(...imageRecordFormats);
    }

    return accepts.join(',');
  }

  export function normalizeUrlForNavigation(rawValue: string | null | undefined): string | null {
    const value = (rawValue ?? '').trim();

    if (!value || value === 'REDACTED') return null;

    // If it already has a scheme (http:, https:, mailto:, etc), keep as-is.
    if (/^[a-zA-Z][a-zA-Z\d+\-.]*:/.test(value)) return value;

    // Protocol-relative.
    if (value.startsWith('//')) return `https:${value}`;

    // Relative URLs should remain relative.
    if (value.startsWith('/') || value.startsWith('#')) return value;

    // Bare domains like "www.example.com" should be treated as absolute.
    return `https://${value}`;
  }
}
